<template>
  <section class="content-section">
    <h1>WÄHLEN SIE AUS EINER VIELZAHL AN MATERIALIEN</h1>
    <div
      class="content-section-info"
      style="text-align:center"
    >Auf ca. 2000 m² Lager- und Produktionsfläche können Sie aus vielen lagernden Natursteinsorten Ihre Auswahl treffen. Aber auch Quarzkomposit, Keramik oder alternative Materialen können Sie bei uns finden, betrachten und gerne auch anfassen! Dabei beraten wir Sie gerne umfassend und kompetent, um den für Sie passenden Naturstein zu finden, der Ihre Anforderungen perfekt erfüllt. Falls mal etwas nicht direkt vorrätig ist besorgen wir es zuverlässig und zeitnah.</div>
    <hr>
    <div class="container columns">
      <div class="info-box column medium" v-for="(leistung, index) in leistungen" :key="index">
        <h3>{{ leistung.title }}</h3>
        <div class="info-box-image">
          <router-link :to="leistung.link" class="info-box-link">Mehr erfahren</router-link>
          <img :src="leistung.image">
        </div>
        <article class="info-box-info">
          <div>{{ leistung.text }}</div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "MaterialUeberblick",
   metaInfo: {
    title: 'Wählen Sie aus einer Vielzahl an Materialien',
    meta:[
      { vmid: 'description', name: 'description', content: "Naturstein im Innen- und Außenbereich erfreut sich einer immer stärkeren Beliebtheit. Ob als Natursteinboden, Naturstein Küchenarbeitsplatte oder in Form von Granit Treppen."},
      { vmid: 'keywords', name: 'keywords', content: "Naturstein Material, Natursteine, Kunststein, Quarzkomposit, Silestone, Ceasarstone, Dekton, Keramik, Mönchengladbach"},
      
    ],
    links: [ {rel: 'canonical', href: 'https://www.marmor-kunze.de/material/natursteine-und-kunststeine'} ]
  },
  data(){
      return{
            leistungen: [
                { 
                    title: "WEICHGESTEINE",
                    image: "https://marmor-kunze.de/static/images/material_weichgestein.jpg",
                    text: "Zu den Weichgesteinen gehören unter anderem: Marmor, Kalksteine, Muschelkalk, Travertin und Serpentinite.",
                    link: "/material/weichgesteine"
                },
                { 
                    title: "HARTGESTEINE",
                    image: "https://marmor-kunze.de/static/images/material_hartgestein.jpg",
                    text: "Zu den Hartgesteinen gehören alle Erstarrungsgesteine, auch Tiefengesteine genannt. Dazu zählen unter anderem Granit und Gabbro. Aber auch Ergussgesteine wie Basalt und Diabas, sowie Gneise gehören den Hartgesteinen an. ",
                    link: "/material/granit-und-hartgesteine"
                },
                { 
                    title: "QUARZKOMPOSIT",
                    image: "https://marmor-kunze.de/static/images/material_quarz.jpg",
                    text: "Quarzkomposit besteht meist aus über 90 Prozent Quarz das mit einem Kunstharz und Farbstoffen zu einem sehr widerstandsfähigem Material zusammengefügt wird.",
                    link: "/material/quarzkomposit"
                },
                { 
                    title: "KERAMIK",
                    image: "https://marmor-kunze.de/static/images/material_keramik.jpg",
                    text: "Keramik, besteht aus natürlichen Materialien wie Ton, Feldspat, Quarz und Mineraloxiden und ist in vielerlei Hinsicht optimal für den Innen- und Außenbereich geeignet. ",
                    link: "/material/keramik"
                }
          ]
      }
  }
};
</script>
j
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/MaterialUeberblick.vue